const galleryId = 10;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": {"en": ""},
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

let group = [];

group = ["sh_1082441426.jpg","sh_1082441432.jpg","sh_1457528537.jpg","sh_1457528549.jpg","sh_1408362344.jpg","sh_1377554240.jpg","sh_1254163063.jpg","sh_1530693896.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Sinus lift - Closed'));

group = ["sh_1710200155.jpg","sh_1669842145.jpg","sh_1669842142.jpg","sh_1710200146.jpg","sh_1669842139.jpg","sh_1669842136.jpg","sh_1669842130.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Sinus lift - Lateral'));

group = ["sh_1710200149.jpg","sh_1710200143.jpg","sh_1530693908.jpg","sh_1408362359.jpg","sh_1530693887.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

export default items;
